import $http from './index.js';
export const GetNoticeList = (data) => {
    return $http.post('api/Notice/GetNoticeList', data);
}

export const GetNoticePageList = (data) => {
    return $http.post('api/Notice/GetNoticePageList', data);
}

export const SaveNotice = (data) => {
    return $http.post('api/Notice/SaveNotice', data);
}
export const DeleteNotice = (data) => {
    return $http.post('api/Notice/DeleteNotice', data);
}
export const ChangeStatus = (data) => {
    return $http.post('api/Notice/ChangeStatus', data);
}
export const GetNotice = (data) => {
    return $http.post('api/Notice/GetNotice', data);
}